import { cartActions } from "./cart.reducer";

const addItemWithoutLogin = async (
  dispatch: any,
  selectedProductOrVariant: any,
  quantity: number,
  currentCollectionId: string | null,
  item?: any,
) => {
  let cartItems = [];

  const cartItemsLocalStorage = localStorage.getItem("cartItems");

  if (cartItemsLocalStorage) {
    cartItems = JSON.parse(cartItemsLocalStorage);
  }

  if (
    cartItems.some(
      (cartItem: any) =>
        cartItem.pk ===
          (selectedProductOrVariant
            ? selectedProductOrVariant.pkCollection
            : item.pk) &&
        cartItem.sk ===
          (selectedProductOrVariant
            ? selectedProductOrVariant.dashboardCollection
            : item.sk),
    )
  ) {
    let tempCartItems = cartItems.map((cartItem: any) => {
      if (
        cartItem.pk ===
          (selectedProductOrVariant
            ? selectedProductOrVariant.pkCollection
            : item.pk) &&
        cartItem.sk ===
          (selectedProductOrVariant
            ? selectedProductOrVariant.dashboardCollection
            : item.sk)
      ) {
        cartItem.quantity += quantity;
        return cartItem;
      } else {
        return cartItem;
      }
    });

    cartItems = tempCartItems;
  } else {
    cartItems.push({
      userId: "",
      cartItemId: "",
      pk: selectedProductOrVariant
        ? selectedProductOrVariant.pkCollection
        : item.pk,
      sk: selectedProductOrVariant
        ? selectedProductOrVariant.dashboardCollection
        : item.sk,
      price: selectedProductOrVariant
        ? selectedProductOrVariant.priceBase
        : item.price,
      priceNow: selectedProductOrVariant
        ? selectedProductOrVariant.priceBase
        : item.priceNow,
      priceSales: selectedProductOrVariant
        ? selectedProductOrVariant.priceSales
        : item.priceSales,
      priceSalesNow: selectedProductOrVariant
        ? selectedProductOrVariant.priceSales
        : item.priceSalesNow,
      quantity,
      collectionId: currentCollectionId
        ? currentCollectionId
        : item.collectionId,
      availableStock: selectedProductOrVariant
        ? selectedProductOrVariant.quantity
        : item.availableStock,
      defaultImage: selectedProductOrVariant
        ? selectedProductOrVariant.imageDefault
        : item.defaultImage,
      title: selectedProductOrVariant
        ? selectedProductOrVariant.title
        : item.title,
      variantOptionsUsed: selectedProductOrVariant
        ? selectedProductOrVariant.variantOptionsUsed
        : item.variantOptionsUsed,
    });
  }

  localStorage.setItem("cartItems", JSON.stringify(cartItems));

  dispatch({
    type: cartActions.addItemSuccess.type,
    payload: cartItems,
  });
};

export const addItem = async (
  dispatch: any,
  currentUser: any,
  selectedProductOrVariant: any,
  quantity: number,
  currentCollectionId: string | null,
  item?: any,
) => {
  if (currentUser) {
    dispatch({
      type: cartActions.addItemStart.type,
      payload: {
        userId: currentUser.nickname,
        cartItemsToAdd: [
          {
            pk: selectedProductOrVariant
              ? selectedProductOrVariant.pkCollection
              : item.pk,
            sk: selectedProductOrVariant
              ? selectedProductOrVariant.dashboardCollection
              : item.sk,
            price: selectedProductOrVariant
              ? selectedProductOrVariant.priceBase
              : item.priceNow,
            priceSales: selectedProductOrVariant
              ? selectedProductOrVariant.priceSales
              : item.priceSalesNow,
            quantity,
            collectionId: currentCollectionId
              ? currentCollectionId
              : item.collectionId,
          },
        ],
      },
    });
  } else {
    addItemWithoutLogin(
      dispatch,
      selectedProductOrVariant,
      quantity,
      currentCollectionId,
      item,
    );
  }
};

const clearItemWithoutLogin = async (dispatch: any, item: any) => {
  let cartItems = [];

  const cartItemsLocalStorage = localStorage.getItem("cartItems");

  if (cartItemsLocalStorage) {
    cartItems = JSON.parse(cartItemsLocalStorage);
  }

  if (
    cartItems.some(
      (cartItem: any) => cartItem.pk === item.pk && cartItem.sk === item.sk,
    )
  ) {
    let tempCartItems = cartItems.filter(
      (cartItem: any) => !(cartItem.pk === item.pk && cartItem.sk === item.sk),
    );

    cartItems = tempCartItems;
  }

  localStorage.setItem("cartItems", JSON.stringify(cartItems));

  dispatch({
    type: cartActions.clearItemSuccess.type,
    payload: cartItems,
  });
};

export const clearItem = async (dispatch: any, currentUser: any, item: any) => {
  if (currentUser) {
    dispatch({
      type: cartActions.clearItemStart.type,
      payload: {
        userId: currentUser?.nickname,
        cartItemIdList: [item.cartItemId],
      },
    });
  } else {
    clearItemWithoutLogin(dispatch, item);
  }
};

const removeItemWithoutLogin = async (dispatch: any, item: any) => {
  let cartItems = [];

  const cartItemsLocalStorage = localStorage.getItem("cartItems");

  if (cartItemsLocalStorage) {
    cartItems = JSON.parse(cartItemsLocalStorage);
  }

  if (
    cartItems.some(
      (cartItem: any) => cartItem.pk === item.pk && cartItem.sk === item.sk,
    )
  ) {
    let tempCartItems = cartItems.map((cartItem: any) => {
      if (cartItem.pk === item.pk && cartItem.sk === item.sk) {
        cartItem.quantity--;
        return cartItem;
      } else {
        return cartItem;
      }
    });

    cartItems = tempCartItems;
  }

  localStorage.setItem("cartItems", JSON.stringify(cartItems));

  dispatch({
    type: cartActions.removeItemSuccess.type,
    payload: cartItems,
  });
};

export const removeItem = async (
  dispatch: any,
  currentUser: any,
  item: any,
) => {
  if (currentUser) {
    dispatch({
      type: cartActions.removeItemStart.type,
      payload: {
        userId: currentUser?.nickname,
        cartItemId: item.cartItemId,
        quantity: item.quantity - 1,
      },
    });
  } else {
    removeItemWithoutLogin(dispatch, item);
  }
};
